import confetti from "canvas-confetti";
import { CHECKOUT_URL } from "@/lib/siteContent";

const burst = () => {
  confetti({
    particleCount: 130,
    spread: 80,
    startVelocity: 42,
    origin: { y: 0.7 },
    colors: ["#D4AF37", "#F0CE6B", "#B8154A", "#FF6B6B", "#FFF9F5"],
  });
};

export const SectionLabel = ({ children }) => (
  <p
    data-testid="section-label"
    className="font-body text-xs sm:text-sm font-medium uppercase tracking-[0.3em] text-gold"
  >
    {children}
  </p>
);

export const BuyButton = ({ children, testId, className = "" }) => (
  <a
    data-testid={testId}
    href={CHECKOUT_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={burst}
    className={`group inline-flex items-center gap-3 rounded-full bg-ruby px-10 py-4 font-body text-sm sm:text-base font-semibold uppercase tracking-[0.2em] text-white shadow-[0_12px_36px_rgba(184,21,74,0.3)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-ruby-dark hover:shadow-[0_16px_44px_rgba(184,21,74,0.4)] ${className}`}
  >
    {children}
  </a>
);

export const GlowPhoto = ({ src, alt, testId, soft = false, position = "center" }) => (
  <div
    data-testid={testId}
    className="relative mx-auto w-full max-w-2xl"
  >
    <div
      className="absolute -inset-6 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.35),transparent_70%)] blur-2xl"
      aria-hidden="true"
    />
    <div className="relative overflow-hidden">
      <img
        src={src}
        alt={alt}
        className={`aspect-[4/3] w-full object-cover ${
          soft ? "blur-[2px] brightness-110 saturate-[1.15]" : ""
        }`}
        style={{ objectPosition: position }}
      />
      <div
        className="absolute inset-0 bg-gradient-to-tr from-ruby/25 via-transparent to-gold/30 mix-blend-soft-light"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-gold/20"
        aria-hidden="true"
      />
    </div>
  </div>
);

export const GoldRule = () => (
  <div className="mx-auto flex items-center justify-center gap-3" aria-hidden="true">
    <span className="h-px w-16 bg-gold-border" />
    <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
    <span className="h-px w-16 bg-gold-border" />
  </div>
);
